<template>
  <p>
    {{ $t("pallet_structure_manual.auto_update") }}
    <input
      :checked="this.pallet.auto_update"
      type="checkbox"
      @input="switchMode"
      :disabled="disableSwitch"
    />
  </p>
</template>

<script>
export default {
  props: ["pallet"],
  data() {
    return {};
  },
  computed: {
    disableSwitch() {
      const disable = this.pallet.auto_update == 1 ? true : false;
      return disable;
    }
  },
  methods: {
    async switchMode() {
      this.pallet.auto_update = 1;
      this.$store.commit('setLoading', true);
      await this.pallet.save();
      this.$emit("updated");
    }
  }
};
</script>
